import { render, staticRenderFns } from "./OrderWorker.vue?vue&type=template&id=e25fa95a&scoped=true&lang=pug&"
import script from "./OrderWorker.vue?vue&type=script&lang=js&"
export * from "./OrderWorker.vue?vue&type=script&lang=js&"
import style0 from "./OrderWorker.vue?vue&type=style&index=0&id=e25fa95a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25fa95a",
  null
  
)

export default component.exports